import { ReactComponent as GoPrevious } from '@assets/svg/arrows-left.svg';
import { ReactComponent as GoNext } from '@assets/svg/arrows-right.svg';
import { PaginationEnum } from './enums/PaginationEnum';
import './style/paginator.style.scss';

interface PaginatorProps {
    onChange?: (page: number, size: number, total: number) => void;
    page: number;
    size: number;
    total: number;
    sizes?: Array<number>;
}

const Paginator: React.FC<PaginatorProps> = ({ page, size, total, onChange }) => {
    const handleOnEdgesClick = (type: PaginationEnum) => {
        switch (type) {
            case PaginationEnum.PREV:
                if (page > 0) {
                    onChange?.(page - 1, size, total);
                }
                break;
            case PaginationEnum.NEXT:
                if (page < Math.ceil(total / size) - 1) {
                    onChange?.(page + 1, size, total);
                }
                break;
        }
    };

    const pages: Array<number> = [];
    for (let i = 0; i < Math.ceil(total / size); i++) {
        pages.push(i);
    }

    const handleOnPageClick = (value: number) => {
        // Avoid onChange if the current page is clicked again
        value !== page && onChange?.(value, size, total);
    };

    const lastPage = pages[pages.length - 1];
    return (
        <>
            {total > 0 && (
                <div id='paginator'>
                    <nav className='pagination-wrapper justify-content-center' aria-label='Navigazione centrata'>
                        <ul className='pagination'>
                            <li>
                                <button
                                    className='paginator-button'
                                    aria-hidden='true'
                                    onClick={() => handleOnEdgesClick(PaginationEnum.PREV)}
                                    style={{ backgroundColor: 'white' }}>
                                    Previous
                                    <span className='visually-hidden'>Pagina precedente</span>
                                </button>
                            </li>
                            {pages.map(pageNumber => (
                                <li>
                                    <button
                                        className={`${pageNumber !== page ? 'paginator-button' : 'paginator-button-active'}`}
                                        aria-hidden='true'
                                        onClick={() => handleOnPageClick(pageNumber)}
                                        key={pageNumber}>
                                        {pageNumber + 1}
                                    </button>
                                </li>
                            ))}
                            <li>
                                <button
                                    className='paginator-button'
                                    aria-hidden='true'
                                    onClick={() => handleOnEdgesClick(PaginationEnum.NEXT)}
                                    style={{ backgroundColor: 'white' }}>
                                    Next
                                    <span className='visually-hidden'>Pagina precedente</span>
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            )}
        </>
    );
};
export default Paginator;
